// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.intro__header {
  padding-top: 1rem;
  padding-left: 1rem;
  font-size: 1.2rem;
}
@media (min-width: 768px) {
  .intro__header {
    font-weight: 600;
    font-size: 1.5rem;
    padding: 1rem 0 1rem 2rem;
  }
}
@media (min-width: 768px) and (min-width: 1280px) {
  .intro__header {
    padding-top: 3rem;
    margin-left: 3rem;
  }
}
.intro__tabsparent {
  display: flex;
  flex-direction: row;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-right: 0.5rem;
}
@media (min-width: 1280px) {
  .intro__tabsparent {
    margin-left: 4rem;
  }
}
.intro__tab {
  cursor: pointer;
  margin-left: 1vw;
  border-bottom: solid 1px lightgray;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  padding-left: 1rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: rgb(238, 234, 234);
  width: 40vw;
}
.intro__tab:hover {
  background-color: white;
  transform: scale(1.02);
  text-align: center;
  font-weight: 600;
}
@media (min-width: 768px) {
  .intro__tab {
    font-size: 1rem;
    padding: 0.5rem 2rem;
  }
  .intro__tab:hover {
    background-color: white;
    transform: scale(1.02);
    text-align: center;
    font-weight: 600;
  }
}
@media (min-width: 1280px) {
  .intro__tab {
    padding: 1.5rem 3rem;
    width: 32.7rem;
    font-size: 1.2rem;
  }
}
@media (min-width: 1280px) {
  .intro__labels {
    width: 40%;
  }
}
.intro__card {
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
}
@media (min-width: 450px) {
  .intro__card {
    width: 50%;
  }
}
@media (min-width: 768px) {
  .intro__card {
    display: flex;
    width: 60%;
    border-radius: 4px;
  }
}
.intro__card--content {
  padding: 0.5rem 0.5rem 1rem 0.5rem;
}
@media (min-width: 768px) {
  .intro__card--content {
    align-self: center;
    padding: 2rem;
    width: 40%;
  }
}
@media (min-width: 1280px) {
  .intro__card--content {
    align-self: center;
    padding: 0.5rem 0.5rem 1rem 0rem;
  }
}
.intro__card--image {
  width: 10rem;
  border-radius: 4px;
  display: block;
  padding-top: 0.5rem;
  width: 90%;
  margin: auto;
}
@media (min-width: 768px) {
  .intro__card--image {
    width: 50%;
    border-radius: 4px;
  }
}
.intro__card--li {
  padding: 0.25rem 0.25rem;
  list-style-type: none;
  font-size: 0.9rem;
  border-bottom: 1px solid rgb(238, 234, 234);
}
@media (min-width: 1280px) {
  .intro__card--li {
    font-size: 1.2rem;
    padding: 1rem 1rem;
  }
}

.active {
  background-color: white;
  transform: scale(1.02);
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
  z-index: 10;
  box-shadow: -10px 3px 8px rgba(0, 0, 0, 0.5);
}
@media (min-width: 768px) {
  .active {
    background-color: white;
    font-size: 1.1rem;
  }
  .active:hover {
    background-color: white;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.intro__card--animate {
  animation: slideIn 1s forwards;
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/components/Introduction/Introduction.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_mixins.scss","webpack://./src/styles/partials/_variables.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAjFI;EACI,iBAAA;EACA,kBAAA;EACA,iBAAA;AAoFR;AE1FI;EFGA;IAKQ,gBAAA;IACA,iBAAA;IACA,yBAAA;EAsFV;AACF;AE5FI;EFFA;IASQ,iBAAA;IACA,iBAAA;EAyFV;AACF;AAtFI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;AAwFR;AEzGI;EFYA;IAOQ,iBAAA;EA0FV;AACF;AAxFI;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCG1BmB;EH2BnB,WAAA;AA0FR;AAzFQ;EACI,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AA2FZ;AEtII;EF2BA;IAmBQ,eAAA;IACA,oBAAA;EA4FV;EA3FU;IACI,uBAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;EA6Fd;AACF;AE7II;EFsBA;IA6BQ,oBAAA;IACA,cAAA;IACA,iBAAA;EA8FV;AACF;AEpJI;EFwDA;IAEQ,UAAA;EA8FV;AACF;AA5FI;EACI,uBAAA;EACA,wCAAA;EACA,kBAAA;AA8FR;AExJI;EFuDA;IAKQ,UAAA;EAgGV;AACF;AExKI;EFkEA;IAQQ,aAAA;IACA,UAAA;IACA,kBAAA;EAkGV;AACF;AAjGQ;EACI,kCAAA;AAmGZ;AElLI;EF8EI;IAGQ,kBAAA;IACA,aAAA;IACA,UAAA;EAqGd;AACF;AEpLI;EFyEI;IAQQ,kBAAA;IACA,gCAAA;EAuGd;AACF;AArGQ;EACI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EAKA,UAAA;EACA,YAAA;AAmGZ;AEvMI;EF0FI;IAiBQ,UAAA;IACA,kBAAA;EAgGd;AACF;AAzFQ;EACI,wBAAA;EACA,qBAAA;EACA,iBAAA;EACA,2CAAA;AA2FZ;AE9MI;EF+GI;IAMQ,iBAAA;IACA,kBAAA;EA6Fd;AACF;;AAzFA;EACI,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,4CAAA;AA4FJ;AEpOI;EFgIJ;IAUQ,uBAAA;IACA,iBAAA;EA8FN;EA7FM;IACI,uBAAA;EA+FV;AACF;;AA5FA;EACI;IAEI,UAAA;EA8FN;EA5FE;IAEI,UAAA;EA6FN;AACF;AA3FA;EACI,8BAAA;AA6FJ","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.intro{\n    &__header{\n        padding-top: 1rem;\n        padding-left: 1rem;\n        font-size: 1.2rem;\n        @include tablet-and-desktop{\n            font-weight: 600;\n            font-size: 1.5rem;\n            padding: 1rem 0 1rem 2rem;\n        @include desktop{\n            padding-top: 3rem;\n            margin-left: 3rem;\n        }\n        }\n    }\n    &__tabsparent{\n        display: flex;\n        flex-direction: row;\n        padding-top: 1rem;\n        padding-bottom: 1rem;\n        margin-right: 0.5rem;\n        @include desktop{\n            margin-left: 4rem;\n        }\n    }\n    &__tab{\n        cursor: pointer;\n        margin-left: 1vw;\n        border-bottom: solid 1px lightgray;\n        transition: all 0.3s ease;\n        font-size: 0.9rem;\n        padding-left: 1rem;\n        padding-right: 0.5rem;\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        background-color: $website-border-lightgray;\n        width: 40vw;\n        &:hover{\n            background-color: white;\n            transform: scale(1.02);\n            text-align: center;\n            font-weight: 600;\n        }\n        @include tablet-and-desktop{\n            font-size: 1rem;\n            padding: 0.5rem 2rem;\n            &:hover{\n                background-color: white;\n                transform: scale(1.02);\n                text-align: center;\n                font-weight: 600;\n            }\n        }\n        @include desktop{\n            padding: 1.5rem 3rem;\n            width:32.7rem;\n            font-size: 1.2rem;\n        }\n    }\n    &__labels{\n        @include desktop{\n            width: 40%;\n        }\n    }\n    &__card{\n        background-color: white;\n        box-shadow: 0 4px 8px rgba(0,0,0,0.5);\n        border-radius: 4px;\n        @include big-mobile-screen{\n            width: 50%;\n        }\n        @include tablet-and-desktop{\n            display: flex;\n            width: 60%;\n            border-radius: 4px;\n        }\n        &--content{\n            padding: 0.5rem 0.5rem 1rem 0.5rem;\n            @include tablet-and-desktop{\n                align-self: center;\n                padding: 2rem;\n                width: 40%;\n            }\n            @include desktop{\n                align-self: center;\n                padding: 0.5rem 0.5rem 1rem 0rem;\n            }\n        }\n        &--image{\n            width: 10rem;\n            border-radius: 4px;\n            display: block;\n            padding-top: 0.5rem;\n            // margin-top: 0.5rem !important;\n            // padding-top: 0.5rem;\n            // margin-right: 0.5ren;\n            // margin-left: 0.5ren;\n            width: 90%;\n            margin: auto;\n            // @include big-mobile-screen{\n            //     width: 90%;\n            //     margin: auto;\n            // }\n            @include tablet-and-desktop{\n                // padding: 1rem;\n                width: 50%;\n                border-radius: 4px;\n            }\n\n            // position: fixed;\n            // top: 20px; /* Adjust as needed */\n            // left: 20px; /* Adjust as needed */\n            // z-index: 10; /* Ensure it's above the content; adjust as needed */\n        }\n        &--li{\n            padding: 0.25rem 0.25rem;\n            list-style-type: none;\n            font-size: 0.9rem;\n            border-bottom: 1px solid $website-border-lightgray;\n            @include desktop{\n                font-size: 1.2rem;\n                padding: 1rem 1rem;\n            }\n        }\n    }\n}\n.active{\n    background-color: white;\n    transform: scale(1.02);\n    text-align: center;\n    font-size: 1rem;\n    font-weight: 600;\n    position: relative;\n    z-index: 10;\n    box-shadow: -10px 3px 8px rgba(0, 0, 0, 0.5);\n    @include tablet-and-desktop{\n        background-color: white;\n        font-size: 1.1rem;\n        &:hover{\n            background-color: white;\n        }\n    }\n}\n@keyframes slideIn {\n    from {\n        // transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        // transform: translateX(0);\n        opacity: 1;\n    }\n}\n.intro__card--animate {\n    animation: slideIn 1s forwards; // Adjust duration as needed\n}\n// .tab1, .tab2, .tab3{\n//     width: 4rem;\n//     height: 4rem;\n//     background-color: red;\n// }","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}","$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n$max-width: 1195px;\n$mobile-header-fontsize: 1rem;\n$mobile-subheader-fontsize: 0.9rem;\n$mobile-content-fontsize: 0.8rem;\n$text-darkgray: rgb(39, 32, 32);\n$text-shadow: #3d3d3d;\n$button-color: #2f7fb0;\n$button-color-hover: #0c4f76;\n$website-darkgray: rgb(44, 43, 43);\n$xeus-darkmaroon: #2f020c;\n$xeus-mediumbeige: rgb(224, 196, 154);\n$xeus-lightbeige: rgb(243, 226, 201);\n$website-border-lightgray: rgb(238, 234, 234);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
